import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import useCopyLink from "../../hooks/useCopyTaskLink";
import { useState } from "react";

export const CopyLinkComponent = ({ ids, task }) => {
  const { t } = useTranslation(["Overlay", "Shared"], {
    useSuspense: false,
  });

  //Hooks
  const { handleCopyLink } = useCopyLink();
  const [copied, setCopied] = useState(false);

  const handleButtonClick = () => {
    handleCopyLink(
      task?.Id,
      () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 3000); //3 seconds
      },
      () => {
        toast.error(t("LinkError"), {
          position: "bottom-left",
        });
      }
    );
  };

  return (
    <div>
      <button
        id={ids.copyTaskLink}
        className={`copy-link-btn ${copied && "copied"}`}
        onClick={handleButtonClick}
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={t("LinkOverlay")}
      >
        {copied ? (
          <span>
            <i className="fa-regular fa-circle-check"></i>
            {t("Copied")}
          </span>
        ) : (
          <>
            {task?.Number}
            <i className="fa-regular fa-link ps-2"></i>
          </>
        )}
      </button>
    </div>
  );
};
